module.exports = __webpack_public_path__ + "img/text-logo.1937a467.svg";